import classNames from 'classnames';
import React from 'react';

import { TabButtonProps } from './TabsTypes';
import useFocusTabs from './hooks/useFocusTabs';
import { useTabsContext } from './hooks/useTabContext';

function TabButton<TValue = string>({
    className,
    children,
    withUnderline = false,
    value,
    ...rest
}: TabButtonProps<TValue>) {
    const { value: selectedValue } = useTabsContext<TValue>();
    const isSelected = selectedValue === value;
    const { onKeydownTabButton, onClickTabButton } = useFocusTabs<TValue>();

    return (
        <button
            id={String(value)}
            className={classNames('sgw-tab-button', className, {
                'is-selected': isSelected,
                'with-underline': withUnderline,
            })}
            type="button"
            role="tab"
            aria-selected={isSelected}
            aria-controls={String(`${value}-tabpanel`)}
            tabIndex={isSelected ? undefined : -1}
            onClick={(e) => onClickTabButton(e, value)}
            onKeyDown={onKeydownTabButton}
            {...rest}
        >
            {children ?? String(`${value}-tabpanel`)}
        </button>
    );
}

export default TabButton;
